// extracted by css-extract-rspack-plugin
export default {"root":"ResizableBoxHandle-module__root___yqonE"};